module.exports = __webpack_public_path__ + "img/background.14341cdb.png";